// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__vqyiD","notfound404":"NotFound_notfound404__iVoOk","notfoundpage":"NotFound_notfoundpage__WN0Tj","notfoundresource":"NotFound_notfoundresource__08lTA"};